import { Component, OnInit, ElementRef, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { GfichierService } from '../../service/gfichier.service';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  @Input() content: string;

  @Output() eventchild = new EventEmitter<string>();

  //@ViewChild('idcheckbox', {static: true}) idcheckbox : ElementRef;
  /*
   isChecked=true;
   mdp : string = "nsi1nsi1";
   email : string = "email";
   */

  isChecked = false;
  mdp: string = "";
  email: string = "";


  constructor(public gfichier: GfichierService,
    private location: LocationStrategy,
  ) {
    // preventing back button in browser implemented by "Samba Siva"  
    history.pushState(null, null, window.location.href);
    this.location.onPopState(() => {
      history.pushState(null, null, window.location.href);
    });
  }

  ngOnInit() {
    this.eventchild.emit("hidebtprecedent");
    this.eventchild.emit("hidebtvalider");
  }

  seconnecter() {

    //  let email : string = this.idmail.nativeElement.value;
    //  let mdp : string = this.idmdp.nativeElement.value;
    //alert(this.isChecked);

    if (this.mdp == "" || this.email == "") alert("les champs sont obligatoires");
    else if (!this.isChecked) alert("Vous devez accepter les conditions d'utilisations.")
    //if(mdp==""||email=="") alert("les champs sont obligatoires");
    else
      this.gfichier.seconnecter(this.email, this.mdp).then(
        successData => {
          //alert(successData[0]);
          //ok ne fonctionne pas
          if (successData[0] == 'o') {
            this.eventchild.emit("changerpage");
            //alert("kjkj"); 
          }
          else
            alert(successData);


        },
        rejectData => {
          console.log(rejectData);
        }
      );


  }


}
